import { AvailableCountryISO3 } from "@/types";

export type BerRatingScale = Map<string, { color: string; level: number }>;

export const LegacyIrlBerRatings: BerRatingScale = new Map([
  ['A1', { color: '#005800', level: 25 }],
  ['A2', { color: '#077806', level: 50 }],
  ['A3', { color: '#119911', level: 75 }],
  ['B1', { color: '#4ba93e', level: 100 }],
  ['B2', { color: '#70b961', level: 125 }],
  ['B3', { color: '#91c983', level: 150 }],
  ['C1', { color: '#b0d9a5', level: 175 }],
  ['C2', { color: '#c5e984', level: 200 }],
  ['C3', { color: '#edf358', level: 225 }],
  ['D1', { color: '#f6da32', level: 260 }],
  ['D2', { color: '#ffc000', level: 300 }],
  ['E1', { color: '#ff9500', level: 340 }],
  ['E2', { color: '#ff6600', level: 380 }],
  ['F', { color: '#eb4a22', level: 450 }],
  ['G', { color: '#d32f2f', level: 550 }],
]);

export const GbrBerRatings: BerRatingScale = new Map([
  ['A', { color: '#02875c', level: 100 }],
  ['B', { color: '#20af5c', level: 91 }],
  ['C', { color: '#8ed344', level: 80 }],
  ['D', { color: '#f4c900', level: 68 }],
  ['E', { color: '#f6b164', level: 54 }],
  ['F', { color: '#f48422', level: 38 }],
  ['G', { color: '#f1203c', level: 20 }],
]);

export const SimplifiedIrlBerRatings: BerRatingScale = new Map([
  ['A0', { color: '#4495d1', level: 42 }],
  ['A', { color: '#00a651', level: 75 }],
  ['B', { color: '#50b848', level: 150 }],
  ['C', { color: '#bfd730', level: 225 }],
  ['D', { color: '#fff200', level: 275 }],
  ['E', { color: '#fdb913', level: 325 }],
  ['F', { color: '#f36f21', level: 375 }],
  ['G', { color: '#ed1d24', level: Number.POSITIVE_INFINITY }],
]);

export const BerRatingScales = {
  [AvailableCountryISO3.GBR]: GbrBerRatings,
  [AvailableCountryISO3.IRL]: SimplifiedIrlBerRatings,
};
